import React, { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { debounce } from "lodash";
import {
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  Icon,
} from "../../components/Component";
import { Button } from "reactstrap";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import UpdateRoleModal from "./modals/UpdateRoleModal";
import DeleteConfirmationModal from "./modals/DeleteConfimationModal";
import TableActions from "../../components/table/TableActions";
import TableTime from "../../components/table/TableTime";

function getDefaultColumns(onEditClick, onDeleteClick) {
  return [
    {
      head: <span className="sub-text">{"Name"}</span>,
      cell: (row) => <span>{row.name}</span>,
    },
    {
      head: <span className="sub-text">{"Type"}</span>,
      cell: (row) => <span>{row.type}</span>,
    },
    {
      head: <span className="sub-text">{"Created at"}</span>,
      cell: (row) => <TableTime value={row?.createdAt} />,
    },
    {
      head: <span className="sub-text"></span>,
      cellClassName: "nk-tb-col-tools",
      cell: (row) => (
        <TableActions
          actions={[
            { label: "Edit", icon: "eye", onClick: () => onEditClick(row) },
            {
              label: "Delete",
              icon: "delete",
              danger: true,
              onClick: () => onDeleteClick(row),
            },
          ]}
        />
      ),
    },
  ];
}
const RolesPage = () => {
  const [smOption, setSmOption] = useState(false);

  const onDelete = (role) => {
    setRoleModalVisible({ role, delete: true });
  };
  const list = [
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
    {
      name: "nguyedinhan",
      type: "Admin",
      createdAt: "2024-01-22T02:36:48.432Z",
    },
  ];
  const _handleInputChange = (value) => {};
  const handleInputChange = debounce(_handleInputChange, 500);
  const [isRoleModalVisible, setRoleModalVisible] = useState({
    role: null,
    update: false,
    delete: false,
  });
  const openModal = (role) => {
    setRoleModalVisible({ role, update: true });
  };
  const closeModal = () => {
    setRoleModalVisible({
      role: null,
      delete: false,
      update: false,
    });
  };
  const dataTableColumns = getDefaultColumns(openModal, onDelete);
  return (
    <React.Fragment>
      <Head title="Roles"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Roles</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by name"
                          onChange={(e) => handleInputChange(e.target.value)}
                        />
                      </div>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle btn-icon d-md-none"
                        color="primary"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <Icon name="plus"></Icon>
                      </Button>
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Roles</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <BasePaginationTable
          list={list}
          columns={dataTableColumns}
          hasNextPage={false}
          totalItems={list.length}
        />
      </Content>
      <UpdateRoleModal
        role={isRoleModalVisible.role}
        isOpen={isRoleModalVisible.update}
        closeModal={closeModal}
      />
      <DeleteConfirmationModal
        isOpen={isRoleModalVisible.delete}
        onCloseModal={closeModal}
      />
    </React.Fragment>
  );
};

export default RolesPage;
